import './Survey.scss';
import '../profile/Status.scss';

import * as Yup from 'yup';

import { Button, Form, Modal, ModalBody } from 'react-bootstrap';
import {
  CUSTOM_QUESTION_TYPE,
  LANGUAGES,
  NOT_AVAILABLE_VALUE,
  PLAYTEST_TYPES,
  gameExperiences
} from '../../utils/constants';
import {
  CandidateSurveyCustomAnswer,
  CustomLocalization,
  CustomQuestion,
  GameExperience,
  Session,
  SurveyGame
} from '../../models/survey';
import { FormattedMessage, useIntl } from 'react-intl';
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import {
  allSurveyGamesNeedUpdate,
  needsGameExperienceUpdate,
  setTitle
} from '../../utils/generic';
import {
  getSurvey,
  getSurveyAnswer,
  postSurvey,
  selectIsFetchingSurvey,
  selectIsFetchingSurveyAnswer,
  selectSurvey,
  selectSurveyAnswer,
  selectSurveyStatus
} from '../../ducks/entities';
import {
  useBeforeUnload,
  useBlocker,
  useNavigate,
  useParams
} from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ControllerExperience from '../../components/ControllerExperience/ControllerExperience';
import Coordinates from '../../components/Coordinates/Coordinates';
import CustomQuestionSection from '../../components/CustomQuestionSection/CustomQuestionSection';
import DifficultyLevel from '../../components/DifficultyLevel/DifficultyLevel';
import DlcContents from '../../components/DlcContents/DlcContents';
import ErrorCard from '../../components/ErrorCard/ErrorCard';
import { FiAlertTriangle } from 'react-icons/fi';
import { Formik } from 'formik';
import FpsControllerExperience from '../../components/FpsControllerExperience/FpsControllerExperience';
import { Game } from '../../models/game';
import GameCard from '../../components/GameCard/GameCard';
import GameModal from '../../components/GameModal/GameModal';
import GamingGenres from '../../components/GamingGenres/GamingGenres';
import HasChildren from '../../components/AboutYou/HasChildren';
import Language from '../../components/Language/Language';
import LoaderComponent from '../../components/Loader/LoaderComponents';
import MobileTesting from '../../components/MobileTesting/MobileTesting';
import PvESocialHabits from '../../components/PvESocialHabits/PvESocialHabits';
import PvPSocialHabits from '../../components/PvPSocialHabits/PvPSocialHabits';
import RemoteTesting from '../../components/RemoteTesting/RemoteTesting';
import ScrollToFieldError from '../../components/ScrollToFieldError/ScrollToFieldError';
import SessionAvailabilitiesCheckboxes from '../../components/SessionAvailabilitiesCheckboxes/SessionAvailabilitiescheckboxes';
import StudioTesting from '../../components/StudioTesting/StudioTesting';
import ToolsSoftwareTesting from '../../components/ToolsSoftwareTesting/ToolsSoftwareTesting';
import UnsavedWarningModal from '../../components/UnsavedWarningModal/UnsavedWarningModal';
import UpdateExpSection from '../../components/UpdateExpSection/UpdateExpSection';
import VrTesting from '../../components/VrTesting/VrTesting';
import WeeklyPlaytime from '../../components/WeeklyPlaytime/WeeklyPlaytime';
import YesNoButton from '../../components/YesNoButton/YesNoButton';
import bannerImg from '../../assets/images/ubisoft-playtest-profile-creation-banner.webp';
import bannerImgMobile from '../../assets/images/ubisoft-playtest-profile-creation-banner-mobile.webp';
import cn from 'classnames';
import iconCalendar from '../../assets/images/ubisoft-playtest-icon-calendar_black.webp';
import iconDots from '../../assets/images/ubisoft-playtest-icon-dots-black.webp';
import iconInfo from '../../assets/images/ubisoft-playtest-profile-icon-information-black.webp';
import iconPS from '../../assets/images/ubisoft-playtest-profile-icon-playstation5-black.webp';
import messages from './messages';
import messagesGamesPlayed from '../profile/messagesGamesPlayed';
import messagesPlaytests from '../profile/messagesPlaytests';
import { selectLanguageSettings } from '../../ducks/settings';
import siteMessages from '../../pages/root/siteMessages';
import { toast } from 'react-toastify';
import { useToggle } from 'react-use';

interface Props {
  isPreview?: boolean;
}

const Survey = (props: Props) => {
  const { surveyId } = useParams();
  const dispatch = useDispatch();
  const intl = useIntl();
  const navigate = useNavigate();
  const surveyStatus = useSelector(selectSurveyStatus);
  const survey = useSelector(selectSurvey);
  const isFetchingSurvey = useSelector(selectIsFetchingSurvey);
  const surveyAnswer = useSelector(selectSurveyAnswer);
  const isFetchingSurveyAnswer = useSelector(selectIsFetchingSurveyAnswer);
  const languageId = useSelector(selectLanguageSettings);
  const [schema, setSchema] = useState<any>();
  const [coordinatesSchema, setCoordinatesSchema] = useState<any>();
  const [weeklyPlaytimeSchema, setWeeklyPlaytimeSchema] = useState<any>();
  const [languageSchema, setLanguageSchema] = useState<any>();
  const [gamingGenresSchema, setGamingGenresSchema] = useState<any>();
  const [controllerExperienceSchema, setControllerExperienceSchema] =
    useState<any>();
  const [fpsControllerExperienceSchema, setFpsControllerExperienceSchema] =
    useState<any>();
  const [difficultyLevelSchema, setDifficultyLevelSchema] = useState<any>();
  const [PvESocialHabitsSchema, setPvESocialHabitsSchema] = useState<any>();
  const [PvPSocialHabitsSchema, setPvPSocialHabitsSchema] = useState<any>();
  const [dlcContentsSchema, setDlcContentsSchema] = useState<any>();
  const [hasChildrenSchema, setHasChildrenSchema] = useState<any>();
  const [remoteTestingSchema, setRemoteTestingSchema] = useState<any>();
  const [studioTestingSchema, setStudioTestingSchema] = useState<any>();
  const [mobileTestingSchema, setMobileTestingSchema] = useState<any>();
  const [toolsSoftwareSchema, setToolsSoftwareSchema] = useState<any>();
  const [
    candidateSurveyCustomAnswerSchema,
    setCandidateSurveyCustomAnswerSchema
  ] = useState<any>();
  const [selectedGame, setSelectedGame] = useState<Game>();
  const [selectedCandidateGame, setSelectedCandidateGame] =
    useState<GameExperience>();
  const [showGameModal, toggleGameModal] = useToggle(false);
  const [showConfirmModal, toggleConfirmModal] = useToggle(false);
  const [isFormModified, setFormModified] = useState(false);
  const [validateOnChange, setValidateOnChange] = useState(false);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isFormModified && currentLocation.pathname !== nextLocation.pathname
  );

  const handleUpdateCustomSchema = useCallback((schema: any) => {
    setCandidateSurveyCustomAnswerSchema(schema);
  }, []);

  useBeforeUnload(
    useCallback(
      (event) => {
        if (!isFormModified) return;
        event.preventDefault();
        event.returnValue = true;
      },
      [isFormModified]
    )
  );

  useEffect(() => {
    setTitle(intl.formatMessage({ ...messages.heading }));
  }, []);

  useEffect(() => {
    if (surveyId) {
      dispatch(getSurvey(surveyId, props.isPreview));
      if (!props.isPreview) dispatch(getSurveyAnswer(surveyId));
    }
  }, [surveyId]);

  useEffect(() => {
    if (surveyStatus !== 200) return;
    let schema = {
      ...coordinatesSchema,
      ...weeklyPlaytimeSchema
    };

    if (survey?.sessions?.length)
      schema = {
        ...schema,
        ...{
          sessionIds: Yup.array(Yup.string()).min(
            1,
            intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
          )
        }
      };
    if (survey?.showLanguage) schema = { ...schema, ...languageSchema };
    if (survey?.showGamingGenre) schema = { ...schema, ...gamingGenresSchema };
    if (survey?.showControllers)
      schema = { ...schema, ...controllerExperienceSchema };
    if (survey?.showFpsControllers)
      schema = { ...schema, ...fpsControllerExperienceSchema };
    if (survey?.showDifficulty)
      schema = { ...schema, ...difficultyLevelSchema };
    if (survey?.showSocialHabitCoop)
      schema = { ...schema, ...PvESocialHabitsSchema };
    if (survey?.showSocialHabitMultiplayer)
      schema = { ...schema, ...PvPSocialHabitsSchema };
    if (survey?.showDlc) schema = { ...schema, ...dlcContentsSchema };
    if (survey?.showHasChildren) schema = { ...schema, ...hasChildrenSchema };
    if (survey?.showRemoteTesting)
      schema = {
        ...schema,
        remoteTesting: Yup.boolean().required(
          intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
        ),
        candidateRemote: Yup.object().when('remoteTesting', {
          is: true,
          then: () =>
            Yup.object()
              .shape({
                ...remoteTestingSchema
              })
              .required(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })),
          otherwise: () => Yup.object().nullable()
        })
      };
    if (survey?.showStudioTesting)
      schema = {
        ...schema,
        studioTesting: Yup.boolean().required(
          intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
        ),
        candidateStudio: Yup.object().when('studioTesting', {
          is: true,
          then: () =>
            Yup.object()
              .shape({
                ...studioTestingSchema
              })
              .required(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })),
          otherwise: () => Yup.object().nullable()
        })
      };
    if (survey?.showMobileTesting)
      schema = {
        ...schema,
        mobileTesting: Yup.boolean().required(
          intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
        ),
        candidateMobile: Yup.object().when('mobileTesting', {
          is: true,
          then: () =>
            Yup.object()
              .shape({
                ...mobileTestingSchema
              })
              .required(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })),
          otherwise: () => Yup.object().nullable()
        })
      };
    if (survey?.showVrTesting)
      schema = {
        ...schema,
        vrTesting: Yup.boolean().required(
          intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
        )
      };

    if (survey?.showToolsSoftwareTesting)
      schema = {
        ...schema,
        toolsSoftwareTesting: Yup.boolean().required(
          intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
        ),
        candidateToolsSoftware: Yup.object().when('toolsSoftwareTesting', {
          is: true,
          then: () =>
            Yup.object()
              .shape({
                ...toolsSoftwareSchema
              })
              .required(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })),
          otherwise: () => Yup.object().nullable()
        })
      };

    if (survey?.surveyGames.length)
      schema = {
        ...schema,
        candidateGameExperiences: Yup.array().of(
          Yup.object({
            played: Yup.boolean().required(
              intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
            )
          })
        )
      };

    if (survey?.customQuestions.length && candidateSurveyCustomAnswerSchema) {
      schema = {
        ...schema,
        candidateSurveyCustomAnswers: Yup.object()
          .shape(candidateSurveyCustomAnswerSchema)
          .nullable()
      };
    }

    setSchema(schema);
  }, [
    surveyStatus,
    coordinatesSchema,
    weeklyPlaytimeSchema,
    languageSchema,
    gamingGenresSchema,
    controllerExperienceSchema,
    fpsControllerExperienceSchema,
    difficultyLevelSchema,
    PvESocialHabitsSchema,
    PvPSocialHabitsSchema,
    dlcContentsSchema,
    hasChildrenSchema,
    remoteTestingSchema,
    mobileTestingSchema,
    candidateSurveyCustomAnswerSchema
  ]);

  useEffect(() => {
    if (!showGameModal) {
      const ele = document.getElementsByClassName('carousel-item active');
      if (ele.length === 0) {
        const items = document.getElementsByClassName('carousel-item');
        if (items.length > 0) {
          document
            .getElementsByClassName('carousel-item')[0]
            .setAttribute('class', 'carousel-item active');
          document
            .querySelector('[data-bs-slide-to="0"]')
            ?.setAttribute('class', 'active');
        }
      }
    }
  }, [showGameModal]);

  if (surveyStatus === 410)
    return (
      <ErrorCard text={intl.formatMessage({ ...messages.surveyExpired })} />
    );
  if (surveyStatus === 409)
    return (
      <ErrorCard text={intl.formatMessage({ ...messages.surveyAnswered })} />
    );
  if (surveyStatus === 403)
    return (
      <ErrorCard text={intl.formatMessage({ ...messages.surveyNotSelected })} />
    );
  if (surveyStatus === 404)
    return (
      <ErrorCard text={intl.formatMessage({ ...messages.surveyNotFound })} />
    );

  const filterDisplayedSessions = (sessions: Session[]) => {
    // implement the filtering of sessions based on candidate studio location
    const filteredSessions = sessions.filter((session) => {
      if (
        session.studioId &&
        survey!.filterSessionsOnLoc &&
        surveyAnswer?.candidateStudio?.studioId
      ) {
        return session.studioId === surveyAnswer.candidateStudio.studioId;
      } else {
        return true;
      }
    });
    // fallback to prevent no sessions being shown
    return filteredSessions.length ? filteredSessions : sessions;
  };

  const getSessionAvailabilitiesOptions = () => {
    if (!survey)
      return [
        {
          value: NOT_AVAILABLE_VALUE,
          label: intl.formatMessage({ ...messages.notAvailable })
        }
      ];
    let sessions = survey?.sessions?.sort((a, b) =>
      a.startDate < b.startDate ? -1 : a.startDate > b.startDate ? 1 : 0
    );
    sessions = filterDisplayedSessions(sessions);
    const options = sessions.map((session) => ({
      value: session.id,
      label: session.customDates?.find(
        (date: CustomLocalization) =>
          date.languageId ===
          LANGUAGES.find((l) => l.id === languageId)?.localizationLanguageId
      )?.text
        ? session.customDates.find(
            (date: CustomLocalization) =>
              date.languageId ===
              LANGUAGES.find((l) => l.id === languageId)!.localizationLanguageId
          )!.text
        : session.customDates.find(
            (date: CustomLocalization) =>
              date.languageId === LANGUAGES[0].localizationLanguageId
          )!.text
    }));
    options.splice(options.length, options.length, {
      value: NOT_AVAILABLE_VALUE,
      label: intl.formatMessage({ ...messages.notAvailable })
    });
    return options;
  };

  const onEdit = (cg: any) => {
    setSelectedCandidateGame(cg);
    toggleGameModal(true);
  };

  const resetAll = () => {
    toggleGameModal(false);
    setSelectedCandidateGame(undefined);
    setSelectedGame(undefined);
  };

  const onSubmit = async (
    values: any,
    { setSubmitting, validateForm }: any
  ) => {
    const formErrors = await validateForm();

    if (Object.keys(formErrors).length > 0) {
      setSubmitting(false);
      return;
    }

    const transformedCustomAnswers = transformCustomAnswers(
      values.candidateSurveyCustomAnswers
    );

    // Additional validation for custom answers
    const mandatoryErrors = validateMandatoryQuestions(
      values.candidateSurveyCustomAnswers,
      survey?.customQuestions || []
    );

    if (Object.keys(mandatoryErrors).length > 0) {
      toast.error(mandatoryErrors);
      setSubmitting(false);
      return;
    }

    values.playtestTypeIds = [];
    if (values.remoteTesting) {
      values.playtestTypeIds.push(PLAYTEST_TYPES.remote);
    } else {
      values.candidateRemote = null;
    }

    if (values.studioTesting) {
      values.playtestTypeIds.push(PLAYTEST_TYPES.studio);
    } else {
      values.candidateStudio = null;
    }

    if (values.mobileTesting) {
      values.playtestTypeIds.push(PLAYTEST_TYPES.mobile);
    } else {
      values.candidateMobile = null;
    }

    if (values.vrTesting) {
      values.playtestTypeIds.push(PLAYTEST_TYPES.vr);
    }

    if (values.toolsSoftwareTesting) {
      values.playtestTypeIds.push(PLAYTEST_TYPES.toolsSoftware);
    } else {
      values.candidateToolsSoftware = null;
    }

    const submitData = {
      ...values,
      candidateSurveyCustomAnswers: transformedCustomAnswers,
      sessionIds: values.sessionIds.filter(
        (id: any) => id !== NOT_AVAILABLE_VALUE
      )
    };

    setSubmitting(true);

    await (dispatch(postSurvey(submitData, surveyId!)) as any)
      .then(() => {
        setSubmitting(false);
        setFormModified(false);
        toggleConfirmModal(true);
      })
      .catch(() => {
        toast.error(intl.formatMessage({ ...messages.sendSurveyFail }));
        setSubmitting(false);
      });
  };

  const onSetField = (
    field: string,
    value: any,
    setFieldValue: any,
    shouldValidate?: boolean | undefined
  ) => {
    setFormModified(true);
    setFieldValue(field, value, shouldValidate);
  };

  const initializeGameExperiences = (
    incomingGameExperiences: GameExperience[]
  ) => {
    const initializedGameExperiences = survey?.surveyGames.map(
      (sg: SurveyGame) => {
        const candidateGame = incomingGameExperiences.find(
          (cg) => cg.id === sg.game?.id
        );

        return candidateGame
          ? { ...candidateGame, updateRequired: sg.updateRequired }
          : {
              id: sg.game?.id,
              igdbGameId: sg.game?.igdbGameId,
              game: sg.game,
              updateRequired: sg.updateRequired,
              lastUpdate: new Date().toISOString(),
              played: false
            };
      }
    );

    return initializedGameExperiences || [];
  };

  const transformCustomAnswers = (answers: any) => {
    // only submit answers for questions that belong to this survey
    const validQuestionIds = new Set(
      (survey?.customQuestions ?? []).map((q: CustomQuestion) => q.id)
    );

    return Object.entries(answers || {})
      .filter(([questionId]) => validQuestionIds.has(questionId))
      .map(([questionId, answer]: [string, any]) => {
        let choiceIds = answer?.surveyCustomQuestionChoiceIds;

        if (choiceIds) {
          if (!Array.isArray(choiceIds)) {
            choiceIds = [choiceIds];
          }
          choiceIds = Array.from(new Set(choiceIds));
          choiceIds = choiceIds.length > 0 ? choiceIds : null;
        } else {
          choiceIds = null;
        }

        return {
          surveyCustomQuestionId: questionId,
          surveyCustomQuestionChoiceIds: choiceIds,
          answerText: answer?.answerText || null,
          answeredYes:
            answer?.answeredYes !== undefined ? answer.answeredYes : null
        };
      })
      .filter(
        (answer) =>
          (Array.isArray(answer.surveyCustomQuestionChoiceIds) &&
            answer.surveyCustomQuestionChoiceIds.length > 0) ||
          answer.answerText ||
          answer.answeredYes !== null
      );
  };

  // Custom validator for mandatory questions
  const validateMandatoryQuestions = (
    answers: any,
    questions: CustomQuestion[]
  ) => {
    const errors: any = {};

    questions?.forEach((question: CustomQuestion) => {
      if (!question.isMandatory) return;

      const answer = answers?.[question.id];
      let hasError = false;
      let errorMessage = 'This field is required';

      switch (question.customQuestionTypeId) {
        case CUSTOM_QUESTION_TYPE.BINARY:
          hasError =
            answer?.answeredYes === null || answer?.answeredYes === undefined;
          break;

        case CUSTOM_QUESTION_TYPE.SINGLE:
        case CUSTOM_QUESTION_TYPE.MULTIPLE:
          hasError =
            !answer?.surveyCustomQuestionChoiceIds ||
            answer.surveyCustomQuestionChoiceIds.length === 0;
          errorMessage = 'Please select an option';
          break;

        case CUSTOM_QUESTION_TYPE.OPEN_ENDED:
          hasError =
            !answer?.answerText || answer.answerText.trim().length === 0;
          errorMessage = 'Please provide an answer';
          break;
      }

      if (hasError) {
        errors[question.id] = { errorMessage };
      }
    });
    return errors;
  };

  // the store can still hold a previously viewed survey while the new one loads
  const isCurrentSurvey =
    !!survey?.id && survey.id.toLowerCase() === surveyId?.toLowerCase();

  return (
    <div className="page">
      {blocker.state === 'blocked' && (
        <UnsavedWarningModal
          onClose={() => blocker.reset()}
          onClick={() => blocker.proceed()}
        />
      )}
      {showConfirmModal && (
        <Modal className="modal-creation" show={showConfirmModal} size="lg">
          <ModalBody>
            <h2 className="mx-4">
              {intl.formatMessage({ ...messages.surveySuccessHeader })}
            </h2>
            <div className="wrapper-bg">
              <span
                dangerouslySetInnerHTML={{
                  __html: intl.formatMessage({ ...messages.surveySuccessBody })
                }}
              />
            </div>
            <div className="wrapper-btn">
              <Button variant="primary" onClick={() => navigate('/')}>
                {intl.formatMessage({ ...messages.goHome })}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      )}
      <div className="page__header">
        <img
          src={bannerImg}
          width="auto"
          alt=""
          className="bannerImg bannerDesktop"
        />
        <img
          src={bannerImgMobile}
          width="auto"
          alt=""
          className="bannerImg bannerMobile"
        />
        <div className="blackOverlay" />
        <div className="content">
          <h1>
            <FormattedMessage {...messages.heading} />
          </h1>
        </div>
      </div>
      <div className="container survey all">
        <div className="w-100">
          {(!isFetchingSurvey &&
            isCurrentSurvey &&
            !props.isPreview &&
            !isFetchingSurveyAnswer &&
            surveyAnswer) ||
          (!isFetchingSurvey && isCurrentSurvey && props.isPreview) ? (
            <Formik
              key={surveyId}
              initialValues={
                props.isPreview
                  ? {
                      sessionIds: [],
                      city: '',
                      phoneNumber: '',
                      postalCode: '',
                      weeklyPlaytimeId: -1,
                      languageId: -1,
                      gamingGenreIds: [],
                      controllerIds: [],
                      fpsControllerIds: [],
                      difficultyId: null,
                      socialHabitCoopIds: [],
                      socialHabitPvpIds: [],
                      dlcTypeIds: [],
                      hasChildren: null,
                      playtestTypeIds: [],
                      candidateRemote: null,
                      candidateStudio: null,
                      candidateMobile: null,
                      candidateToolsSoftware: null,
                      remoteTesting: null,
                      studioTesting: null,
                      mobileTesting: null,
                      vrTesting: null,
                      toolsSoftwareTesting: null,
                      candidateGameExperiences: survey?.surveyGames?.map(
                        (sg: SurveyGame) => ({
                          id: sg.game.id,
                          igdbGameId: sg.game.igdbGameId,
                          game: sg.game,
                          updateRequired: sg.updateRequired,
                          lastUpdate: new Date().toISOString(),
                          played: false
                        })
                      ),
                      candidateSurveyCustomAnswers: {}
                    }
                  : {
                      ...surveyAnswer,
                      remoteTesting: surveyAnswer?.playtestTypeIds.includes(
                        PLAYTEST_TYPES.remote
                      ),
                      mobileTesting: surveyAnswer?.playtestTypeIds.includes(
                        PLAYTEST_TYPES.mobile
                      ),
                      studioTesting: surveyAnswer?.playtestTypeIds.includes(
                        PLAYTEST_TYPES.studio
                      ),
                      vrTesting: surveyAnswer?.playtestTypeIds.includes(
                        PLAYTEST_TYPES.vr
                      ),
                      toolsSoftwareTesting:
                        surveyAnswer?.playtestTypeIds.includes(
                          PLAYTEST_TYPES.toolsSoftware
                        ),
                      candidateGameExperiences: initializeGameExperiences(
                        surveyAnswer!.candidateGameExperiences
                      ),
                      candidateSurveyCustomAnswers:
                        surveyAnswer?.candidateSurveyCustomAnswers?.reduce(
                          (acc: any, answer: CandidateSurveyCustomAnswer) => ({
                            ...acc,
                            [answer.surveyCustomQuestionId]: answer
                          }),
                          {}
                        ) || {}
                    }
              }
              validationSchema={Yup.object().shape(schema)}
              onSubmit={onSubmit}
              validateOnChange={validateOnChange}
            >
              {({
                values,
                errors,
                handleChange,
                handleSubmit,
                isSubmitting,
                setFieldValue
              }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <ScrollToFieldError />
                  {showGameModal && (
                    <GameModal
                      game={selectedGame}
                      gameExperience={selectedCandidateGame}
                      onClose={resetAll}
                      submit={false}
                      onChangeValues={(newValues: any) => {
                        setFieldValue(
                          'candidateGameExperiences',
                          values.candidateGameExperiences?.map((cg: any) =>
                            cg.id === newValues.id
                              ? { ...newValues, played: true }
                              : cg
                          )
                        );
                      }}
                      onDelete={(id: string) => {
                        setFieldValue(
                          'candidateGameExperiences',
                          values.candidateGameExperiences?.map((cg: any) =>
                            cg.id === id ? { ...cg, played: null } : cg
                          )
                        );
                      }}
                    />
                  )}
                  {survey.customHeaders?.length > 0 && (
                    <p
                      className="survey-customHeaders"
                      dangerouslySetInnerHTML={{
                        __html:
                          survey.customHeaders.find(
                            (header: any) =>
                              header.languageId ===
                              LANGUAGES.find((l) => l.id === languageId)
                                ?.localizationLanguageId
                          )?.text || survey.customHeaders[0].text
                      }}
                    />
                  )}
                  <div className="required-field">
                    <p>{intl.formatMessage({ ...messages.fieldRequired })}</p>
                  </div>
                  <div>
                    <div className="header">
                      <img
                        src={iconCalendar}
                        alt=""
                        className="survey-calendar"
                      />
                      <h3>
                        {intl.formatMessage({
                          ...messages.headerPlaytestAvailabilities
                        })}
                      </h3>
                    </div>
                    <div className="content">
                      {survey.sessions?.length > 0 && (
                        <Form.Group controlId="sessionIds">
                          <Form.Label className="availabilities-title">
                            {intl.formatMessage({
                              ...messages.sessionAvailabilities
                            })}
                          </Form.Label>
                          <SessionAvailabilitiesCheckboxes
                            options={getSessionAvailabilitiesOptions()}
                            onChange={(value: any) => {
                              if (value.length > 0) setFormModified(true);
                              setFieldValue('sessionIds', value);
                            }}
                          />
                          {errors.sessionIds && (
                            <div className="feedback">
                              <FiAlertTriangle className="mb-1 me-1" />
                              {errors.sessionIds}
                            </div>
                          )}
                        </Form.Group>
                      )}
                    </div>
                  </div>
                  <Coordinates
                    values={values}
                    errors={errors}
                    handleChange={(e: any) => {
                      handleChange(e);
                      setFormModified(true);
                    }}
                    updateSchema={(schema) => setCoordinatesSchema(schema)}
                  />
                  <div className="additionalInfo">
                    <div className="header">
                      <img src={iconInfo} alt="" className="mt-n1" />
                      <h3>
                        {intl.formatMessage({
                          ...messages.headerAdditionalInfo
                        })}
                      </h3>
                    </div>
                    <div className="content">
                      <WeeklyPlaytime
                        values={values}
                        errors={errors}
                        setFieldValue={(
                          field: string,
                          value: any,
                          shouldValidate?: boolean | undefined
                        ) =>
                          onSetField(
                            field,
                            value,
                            setFieldValue,
                            shouldValidate
                          )
                        }
                        updateSchema={(schema) =>
                          setWeeklyPlaytimeSchema(schema)
                        }
                      />
                      {survey.showLanguage && (
                        <Language
                          values={values}
                          errors={errors}
                          setFieldValue={(
                            field: string,
                            value: any,
                            shouldValidate?: boolean | undefined
                          ) =>
                            onSetField(
                              field,
                              value,
                              setFieldValue,
                              shouldValidate
                            )
                          }
                          isEnglishAbility={false}
                          hasLabel={true}
                          updateSchema={(schema) => setLanguageSchema(schema)}
                        />
                      )}
                      {survey.showGamingGenre && (
                        <GamingGenres
                          values={values}
                          errors={errors}
                          setFieldValue={(
                            field: string,
                            value: any,
                            shouldValidate?: boolean | undefined
                          ) =>
                            onSetField(
                              field,
                              value,
                              setFieldValue,
                              shouldValidate
                            )
                          }
                          updateSchema={(schema) =>
                            setGamingGenresSchema(schema)
                          }
                        />
                      )}
                      {survey.showControllers && (
                        <ControllerExperience
                          values={values}
                          errors={errors}
                          setFieldValue={(
                            field: string,
                            value: any,
                            shouldValidate?: boolean | undefined
                          ) =>
                            onSetField(
                              field,
                              value,
                              setFieldValue,
                              shouldValidate
                            )
                          }
                          updateSchema={(schema) =>
                            setControllerExperienceSchema(schema)
                          }
                        />
                      )}
                      {survey.showFpsControllers && (
                        <FpsControllerExperience
                          values={values}
                          errors={errors}
                          setFieldValue={(
                            field: string,
                            value: any,
                            shouldValidate?: boolean | undefined
                          ) =>
                            onSetField(
                              field,
                              value,
                              setFieldValue,
                              shouldValidate
                            )
                          }
                          updateSchema={(schema) =>
                            setFpsControllerExperienceSchema(schema)
                          }
                        />
                      )}
                      {survey.showDifficulty && (
                        <DifficultyLevel
                          values={values}
                          errors={errors}
                          setFieldValue={(
                            field: string,
                            value: any,
                            shouldValidate?: boolean | undefined
                          ) =>
                            onSetField(
                              field,
                              value,
                              setFieldValue,
                              shouldValidate
                            )
                          }
                          updateSchema={(schema) =>
                            setDifficultyLevelSchema(schema)
                          }
                        />
                      )}
                      {survey.showSocialHabitCoop && (
                        <PvESocialHabits
                          values={values}
                          errors={errors}
                          setFieldValue={(
                            field: string,
                            value: any,
                            shouldValidate?: boolean | undefined
                          ) =>
                            onSetField(
                              field,
                              value,
                              setFieldValue,
                              shouldValidate
                            )
                          }
                          updateSchema={(schema) =>
                            setPvESocialHabitsSchema(schema)
                          }
                        />
                      )}
                      {survey.showSocialHabitMultiplayer && (
                        <PvPSocialHabits
                          values={values}
                          errors={errors}
                          setFieldValue={(
                            field: string,
                            value: any,
                            shouldValidate?: boolean | undefined
                          ) =>
                            onSetField(
                              field,
                              value,
                              setFieldValue,
                              shouldValidate
                            )
                          }
                          updateSchema={(schema) =>
                            setPvPSocialHabitsSchema(schema)
                          }
                        />
                      )}
                      {survey.showDlc && (
                        <DlcContents
                          values={values}
                          errors={errors}
                          setFieldValue={(
                            field: string,
                            value: any,
                            shouldValidate?: boolean | undefined
                          ) =>
                            onSetField(
                              field,
                              value,
                              setFieldValue,
                              shouldValidate
                            )
                          }
                          updateSchema={(schema) =>
                            setDlcContentsSchema(schema)
                          }
                        />
                      )}
                      {survey.showHasChildren && (
                        <>
                          <hr className="line" />
                          <div className="hasChildren">
                            <HasChildren
                              value={values.hasChildren}
                              error={errors.hasChildren}
                              setFieldValue={(
                                field: string,
                                value: any,
                                shouldValidate?: boolean | undefined
                              ) =>
                                onSetField(
                                  field,
                                  value,
                                  setFieldValue,
                                  shouldValidate
                                )
                              }
                              updateSchema={(schema) =>
                                setHasChildrenSchema(schema)
                              }
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  {survey.customQuestions?.length > 0 && (
                    <>
                      <CustomQuestionSection
                        title={intl.formatMessage({
                          ...messages.headerAdditionalPlaystestQuestions
                        })}
                        values={values.candidateSurveyCustomAnswers}
                        currentLanguageId={languageId}
                        questions={survey.customQuestions}
                        errors={errors.candidateSurveyCustomAnswers}
                        setFieldValue={setFieldValue}
                        updateSchema={handleUpdateCustomSchema}
                      />
                    </>
                  )}
                  {(survey.showRemoteTesting ||
                    survey.showMobileTesting ||
                    survey.showStudioTesting ||
                    survey.showVrTesting ||
                    survey.showToolsSoftwareTesting) && (
                    <div className="playtestInterests">
                      <div className="header">
                        <img src={iconDots} alt="" className="mt-n1" />
                        <h3>
                          {intl.formatMessage({
                            ...messagesPlaytests.headerPlaytestTypes
                          })}
                        </h3>
                      </div>
                      <div className="content">
                        <p className="pleaseSelect">
                          {intl.formatMessage({
                            ...messages.pleaseSelectText
                          })}
                        </p>
                        {survey.showRemoteTesting && (
                          <RemoteTesting
                            isInterested={values.remoteTesting ?? null}
                            values={values.candidateRemote ?? {}}
                            errors={errors.candidateRemote}
                            setFieldValue={(
                              field: string,
                              value: any,
                              shouldValidate?: boolean | undefined
                            ) =>
                              onSetField(
                                field,
                                value,
                                setFieldValue,
                                shouldValidate
                              )
                            }
                            updateSchema={(schema) =>
                              setRemoteTestingSchema(schema)
                            }
                            withHeader={false}
                          />
                        )}
                        {survey.showStudioTesting && (
                          <>
                            {survey.showRemoteTesting && (
                              <hr className="line" />
                            )}
                            <StudioTesting
                              isInterested={values.studioTesting ?? null}
                              values={values.candidateStudio ?? {}}
                              errors={errors.candidateStudio}
                              setFieldValue={(
                                field: string,
                                value: any,
                                shouldValidate?: boolean | undefined
                              ) =>
                                onSetField(
                                  field,
                                  value,
                                  setFieldValue,
                                  shouldValidate
                                )
                              }
                              updateSchema={(schema) =>
                                setStudioTestingSchema(schema)
                              }
                              withHeader={false}
                            />
                          </>
                        )}
                        {survey.showMobileTesting && (
                          <>
                            {(survey.showRemoteTesting ||
                              survey.showStudioTesting) && (
                              <hr className="line" />
                            )}
                            <MobileTesting
                              isInterested={values.mobileTesting ?? null}
                              values={values.candidateMobile ?? {}}
                              errors={errors.candidateMobile}
                              setFieldValue={(
                                field: string,
                                value: any,
                                shouldValidate?: boolean | undefined
                              ) =>
                                onSetField(
                                  field,
                                  value,
                                  setFieldValue,
                                  shouldValidate
                                )
                              }
                              updateSchema={(schema) =>
                                setMobileTestingSchema(schema)
                              }
                              withHeader={false}
                              isSurvey={true}
                            />
                          </>
                        )}
                        {survey.showVrTesting && (
                          <>
                            {(survey.showRemoteTesting ||
                              survey.showStudioTesting ||
                              survey.showMobileTesting) && (
                              <hr className="line" />
                            )}
                            <VrTesting
                              isInterested={values.vrTesting ?? null}
                              setFieldValue={(
                                field: string,
                                value: any,
                                shouldValidate?: boolean | undefined
                              ) =>
                                onSetField(
                                  field,
                                  value,
                                  setFieldValue,
                                  shouldValidate
                                )
                              }
                              withHeader={false}
                              isSurvey={true}
                            />
                          </>
                        )}
                        {survey.showToolsSoftwareTesting && (
                          <>
                            {(survey.showRemoteTesting ||
                              survey.showStudioTesting ||
                              survey.showMobileTesting ||
                              survey.showVrTesting) && <hr className="line" />}
                            <ToolsSoftwareTesting
                              isInterested={values.toolsSoftwareTesting ?? null}
                              values={values.candidateToolsSoftware ?? {}}
                              errors={errors.candidateToolsSoftware}
                              setFieldValue={(
                                field: string,
                                value: any,
                                shouldValidate?: boolean | undefined
                              ) =>
                                onSetField(
                                  field,
                                  value,
                                  setFieldValue,
                                  shouldValidate
                                )
                              }
                              updateSchema={(schema) =>
                                setToolsSoftwareSchema(schema)
                              }
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  {survey.surveyGames?.length > 0 &&
                    !allSurveyGamesNeedUpdate(
                      values.candidateGameExperiences,
                      survey.surveyGames
                    ) && (
                      <div className="gamesPlayed">
                        <div className="header">
                          <img src={iconPS} alt="" className="mt-n1" />
                          <h3>
                            {intl.formatMessage({
                              ...messagesGamesPlayed.headerGamesPlayed
                            })}
                          </h3>
                        </div>
                        <div className="gamesPlayed-content">
                          <p className="mb-2">
                            {intl.formatMessage({
                              ...messages.descriptionGamesPlayed
                            })}
                          </p>
                          <p
                            className="poweredBy"
                            dangerouslySetInnerHTML={{
                              __html: intl.formatMessage({
                                ...messagesGamesPlayed.poweredByIGDB
                              })
                            }}
                          />
                          {values.candidateGameExperiences?.filter(
                            (cg: any) =>
                              !cg.updateRequired ||
                              (cg.played &&
                                cg.updateRequired &&
                                cg.lastUpdate &&
                                !needsGameExperienceUpdate(cg))
                          ).length > 0 && (
                            <>
                              <div
                                id="carouselGamesPlayed"
                                className="carousel slide mt-4"
                                data-bs-ride="false"
                              >
                                <div className="carousel-inner">
                                  {values
                                    .candidateGameExperiences!.filter(
                                      (cg: any) =>
                                        cg.played &&
                                        !needsGameExperienceUpdate(cg)
                                    )
                                    .map((cg: any, index: number) => (
                                      <div
                                        className={cn(
                                          'carousel-item',
                                          index === 0 ? 'active' : ''
                                        )}
                                        key={index}
                                      >
                                        <div className="grid d-flex justify-content-center pb-5">
                                          <GameCard
                                            key={cg.id}
                                            gameExperience={cg}
                                            onEdit={() => {
                                              setFormModified(true);
                                              onEdit(cg);
                                            }}
                                          />
                                        </div>
                                      </div>
                                    ))}
                                  <div className="carousel-indicators">
                                    {values
                                      .candidateGameExperiences!.filter(
                                        (cg: any) =>
                                          cg.played &&
                                          !needsGameExperienceUpdate(cg)
                                      )
                                      .map((cg: any, index: number) => (
                                        <button
                                          key={index}
                                          type="button"
                                          data-bs-target="#carouselGamesPlayed"
                                          data-bs-slide-to={index}
                                          className={cn(
                                            index === 0 ? 'active' : ''
                                          )}
                                          aria-current={
                                            index === 0 ? 'true' : 'false'
                                          }
                                          aria-label={cg.game?.name}
                                        ></button>
                                      ))}
                                  </div>
                                </div>
                                <button
                                  className="carousel-control-prev"
                                  type="button"
                                  data-bs-target="#carouselGamesPlayed"
                                  data-bs-slide="prev"
                                >
                                  <MdNavigateBefore
                                    className="prev-icon"
                                    aria-hidden="true"
                                  />
                                </button>
                                <button
                                  className="carousel-control-next"
                                  type="button"
                                  data-bs-target="#carouselGamesPlayed"
                                  data-bs-slide="next"
                                >
                                  <MdNavigateNext
                                    className="next-icon"
                                    aria-hidden="true"
                                  />
                                </button>
                              </div>
                              <div
                                id="gridGamesPlayed"
                                className={cn(
                                  'grid',
                                  values.candidateGameExperiences?.filter(
                                    (cg: any) =>
                                      !cg.played &&
                                      !needsGameExperienceUpdate(cg)
                                  ).length > 0
                                    ? 'line-bottom'
                                    : ''
                                )}
                              >
                                {values.candidateGameExperiences
                                  ?.filter(
                                    (cg: any) =>
                                      cg.played &&
                                      !needsGameExperienceUpdate(cg)
                                  )
                                  .map((cg: any) => (
                                    <GameCard
                                      key={cg.id}
                                      gameExperience={cg}
                                      onEdit={() => {
                                        setFormModified(true);
                                        onEdit(cg);
                                      }}
                                    />
                                  ))}
                              </div>
                            </>
                          )}
                          <div id="candidateGameExperiences">
                            {values.candidateGameExperiences
                              ?.filter((cg: any) => !cg.played)
                              .map((cg: any, index: number) => (
                                <div key={index} className="yesnoQuestion">
                                  <YesNoButton
                                    key={cg.id}
                                    name={cg.game?.name}
                                    label={`${intl.formatMessage({
                                      ...messages.havePlayed
                                    })} ${cg.game?.name}`}
                                    value={cg.played}
                                    onChange={(value: any) => {
                                      setFormModified(true);
                                      if (value) {
                                        setFieldValue(
                                          'candidateGameExperiences',
                                          values.candidateGameExperiences?.map(
                                            (game: any) =>
                                              game.id === cg.id
                                                ? { ...game, played: null }
                                                : game
                                          )
                                        );
                                        setSelectedGame(
                                          survey.surveyGames?.find(
                                            (sg) => sg.gameId === cg.id
                                          )?.game
                                        );
                                        setSelectedCandidateGame(cg);
                                        toggleGameModal(true);
                                      } else {
                                        // populate unanswered fields with 'DidNotPlay' value if the game has those modes
                                        const defaultUnansweredValue =
                                          gameExperiences.find(
                                            (entry) =>
                                              entry.name ===
                                              'gameExperiences.DidNotPlay'
                                          )!.id;
                                        const newGameExperiences =
                                          values.candidateGameExperiences?.map(
                                            (gameExp: any) =>
                                              gameExp.id === cg.id
                                                ? {
                                                    ...gameExp,
                                                    singleExperienceId: gameExp
                                                      .game.singlePlayerMode
                                                      ? defaultUnansweredValue
                                                      : undefined,
                                                    multiExperienceId: gameExp
                                                      .game.multiplayerMode
                                                      ? defaultUnansweredValue
                                                      : undefined,
                                                    coopExperienceId: gameExp
                                                      .game.coopMode
                                                      ? defaultUnansweredValue
                                                      : undefined,
                                                    played: value,
                                                    liked: undefined,
                                                    finished: undefined
                                                  }
                                                : gameExp
                                          );
                                        setFieldValue(
                                          'candidateGameExperiences',
                                          newGameExperiences
                                        );
                                      }
                                    }}
                                    error={
                                      errors.candidateGameExperiences &&
                                      errors.candidateGameExperiences[
                                        values.candidateGameExperiences?.findIndex(
                                          (g) => g.id === cg.id
                                        )
                                        // eslint-disable-next-line
                                      // @ts-ignore
                                      ]?.played
                                    }
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    )}
                  {values.candidateGameExperiences?.filter((cg: any) => {
                    if (!cg.updateRequired || !cg.lastUpdate || !cg.played)
                      return false;
                    return needsGameExperienceUpdate(cg);
                  }).length > 0 && (
                    <UpdateExpSection
                      title={intl.formatMessage({
                        ...messages.headerUpdateGameExp
                      })}
                      description={intl.formatMessage({
                        ...messages.descriptionGameExp
                      })}
                      values={values?.candidateGameExperiences}
                      setFormModified={setFormModified}
                      onEdit={onEdit}
                    />
                  )}
                  <div className="btns-save">
                    <Button
                      className="m-2"
                      variant="primary"
                      disabled={props.isPreview ? true : isSubmitting}
                      onClick={() => {
                        setValidateOnChange(true);
                        handleSubmit();
                      }}
                    >
                      <LoaderComponent
                        isLoading={isSubmitting}
                        className="lds-small"
                      >
                        {intl.formatMessage({ ...messages.submit })}
                      </LoaderComponent>
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          ) : (
            <div className="loading">
              {[...Array(9).keys()].map((i) => (
                <p key={`survey-${i}`} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Survey;
